import React from 'react';

const Thanks = (props) => {
    return(
        <h1 style={{textAlign: "center"}}>Thank You for Your Order!</h1>
    );
};

export default Thanks;